import React from 'react';
import TaskModelView from './taskModelView';

// La vue porte sa propre fiche : cet enrobage n'ajoutait qu'une grille.
function TasksModel() {
  return <TaskModelView />;
}

export default TasksModel;
